<loading-wrapper [loading]="!captchaLoaded">
  <re-captcha
    size="compact"
    (resolved)="resolved($event)"
    siteKey="{{ siteKeyCaptchaV2 }}"
  ></re-captcha>
</loading-wrapper>
